﻿import React, { useEffect, useState, useRef } from "react";
import axios from "../../features/axiosHelper";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Typography,
  Box,
  InputAdornment,
  TextField,
  Button,
  Link,
} from "@mui/material";
import StageCheckbox from "./StageCheckbox";
import "./SettingsPopUp.css";
import { SearchInactive } from "../../ImageRepo";
import PopUpDataGrid from "@/components/DataGrid/PopUpDataGrid";
import { GridLogicOperator } from "@/components/DataGrid/CardDataGrid";
import {
  setCurrentOperation,
  selectCurrentOperationId,
  setCurrentConnectionPair,
  selectCurrentConnectionPair,
} from "@/features/operations/operationsSlice";
// import { useHistory } from "react-router-dom";

const SettingsPopUp = ({ showStage = true, onClose }) => {
  const dispatch = useDispatch();
  const gridRef = useRef(null); //reference for the grid is created here
  const [connectionPairDetails, setConnectionPairDetails] = useState([]);
  const [connectionPair, setConnectionPair] = useState(
    useSelector(selectCurrentConnectionPair)
  );
  const [operationId, setOperationId] = useState(
    useSelector(selectCurrentOperationId)
  );

  const columns = [
    {
      field: "connectionPairName",
      headerName: "Name",
      flex: 1,
    },
  ];

  useEffect(() => {
    getConnectionPairDetails();
  }, []);

  const getConnectionPairDetails = () => {
    axios
      .get("/connectionpair", {
        params: { clearCache: false },
      })
      .then((response) => {
        setConnectionPairDetails(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };

  const handleInputFieldOnBlur = (event) => {
    let connection = event.target.value;

    //popover filter for the grid
    let gridFilterModel = gridRef.current.getGridFilter();
    let newFilter = gridFilterModel.items.filter((f) => {
      return f.field != "connectionName";
    });
    if (connection != "") {
      newFilter.push({
        id: "connectionName",
        field: "connectionName",
        operator: "contains",
        value: connection,
      });
    }
    gridRef.current.setGridFilter({
      items: newFilter,
      logicOperator: GridLogicOperator.Or,
    });
  };

  const handleCheckboxChange = (operationId) => {
    setOperationId(operationId[0]);
  };

  const onSelectedRowsChange = (rows) => {
    let connectionPair = null;
    if (rows.length > 0) {
      connectionPair = rows[0];
    }
    setConnectionPair(connectionPair);
  };

  const onClickSave = () => {
    dispatch(
      setCurrentConnectionPair({
        currentConnectionPair: connectionPair,
      })
    );
    dispatch(setCurrentOperation({ currentOperationId: operationId }));
    if (onClose) onClose();
  };
  return (
    <Container>
      {showStage && (
        <>
          <Box className="settings-header-container">
            <Typography gutterBottom variant="h2">
              Select Stage(s)
            </Typography>
          </Box>
          <Box className="settings-sub-header-container">
            <Typography
              className="settings-sub-headline"
              gutterBottom
              variant="body1"
            >
              Please Select Stage
            </Typography>
          </Box>
          <StageCheckbox
            selectedStages={[operationId]}
            onCheckboxChange={handleCheckboxChange}
          />
        </>
      )}
      <Box className="connection-header-container">
        <Typography gutterBottom variant="h2">
          Connection Pair Selection
        </Typography>
      </Box>
      <Box>
        <Typography
          className="connection-sub-headline"
          gutterBottom
          variant="body1"
        >
          Search and select Connection Pair
        </Typography>
      </Box>
      <Box className="textbox-container">
        <TextField
          variant="outlined"
          style={{ width: "100%" }}
          onBlur={handleInputFieldOnBlur}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <img
                  src={SearchInactive}
                  className="secondary-icon"
                  alt="Icon"
                />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Box className="grid-container">
        <PopUpDataGrid
          ref={gridRef}
          rows={connectionPairDetails}
          columns={columns}
          whiteHeader={true}
          checkboxSelection={true}
          forceDisableMultipleSelection={true}
          onSelectedRowsChange={onSelectedRowsChange}
        />
      </Box>
      <Box className="button-container">
        <Button
          disabled={operationId == null || connectionPair == null}
          className="btn-primary"
          style={{ width: 180, margin: "2px 0px" }}
          onClick={onClickSave}
        >
          Save
        </Button>
      </Box>
    </Container>
  );
};

export default SettingsPopUp;
